import { useSnackbar } from "notistack";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import {
  BaseQueryProps,
  BaseSearchQueryProps,
  ListResponseData,
  Tractor,
  TractorInput,
} from "../types";
import {
  handleDelete,
  handleDetail,
  handleList,
  handleMutationError,
  handleQueryError,
  handleSave,
  handleSearch,
} from "./handler";

const methods = {
  useSearch: ({ query }: BaseSearchQueryProps) => {
    const navigate = useNavigate();
    return useQuery<Tractor[]>({
      queryKey: ["tractors", query],
      queryFn: () => handleSearch({ baseUrl: "tractors", query }),
      onError: handleQueryError(navigate),
    });
  },
  useSave: (tractorInput: TractorInput) => {
    const navigate = useNavigate();
    return useMutation<Tractor>({
      mutationFn: () =>
        handleSave({ baseUrl: "tractors", input: tractorInput }),
      onError: handleQueryError(navigate),
      retry: 1,
    });
  },
  useList: ({ order, orderBy, page, query }: BaseQueryProps<Tractor>) => {
    const navigate = useNavigate();
    return useQuery<ListResponseData<Tractor>>({
      cacheTime: 0,
      queryKey: ["tractors", order, orderBy, page, query],
      queryFn: () =>
        handleList({ baseUrl: "tractors", order, orderBy, page, query }),
      onError: handleQueryError(navigate),
    });
  },
  useDetail: (id: string | undefined) => {
    const navigate = useNavigate();
    return useQuery<Tractor>({
      cacheTime: 0,
      queryKey: ["tractor", id],
      queryFn: () => handleDetail({ baseUrl: "tractors", id }),
      onError: handleQueryError(navigate),
    });
  },
  useDelete: (id?: number) => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation<Tractor>({
      mutationFn: () => handleDelete({ baseUrl: "tractors", id }),
      retry: 1,
      onError: handleMutationError(enqueueSnackbar),
    });
  },
};

export default methods;
